import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { OutletModule } from '@spartacus/storefront';
import { NotifyMeModule } from '../notify-me/notify-me.module';
import { ProductSizeChartModule } from '../product-size-chart/product-size-chart.module';
import { ProductStockInfoComponent } from './product-stock-info.component';

@NgModule({
  declarations: [ProductStockInfoComponent],
  imports: [CommonModule, OutletModule, I18nModule, MatIconModule, NotifyMeModule, ProductSizeChartModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductStockInfoComponent: {
          component: ProductStockInfoComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductStockInfoComponent],
})
export class ProductStockInfoModule {}
